var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"tree-card"},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.treeData,"props":_vm.defaultProps,"node-key":"id","highlight-current":""},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }